<template>
    <v-container px-4 pa-0 class="container-with-horizontal-scroll" fluid>
      <v-toolbar dense flat color="transparent">
        <v-spacer></v-spacer>
        <v-tooltip right bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="loadMessages" v-on="on">
              <v-icon :color="'success'">forum</v-icon>
            </v-btn>
          </template>
          <span class="caption">Перезагрузить сообщения</span>
        </v-tooltip>
      </v-toolbar>
      <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" class="pa-1 ma-0">
                <v-card class="blue-grey lighten-5">
                    <v-card-title class="ml-2 pa-1">
                        <v-list-item-title class="bold subtitle-1">
                            Сообщения
                        </v-list-item-title>
                    </v-card-title>
                    <div v-bind:style="[{height: (windowHeight - 160) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                        <div class="content">
                            <v-card-text class="pa-0 ma-0"
                                         v-for="(messageDialog, index) in messagesDialog"
                                         :key="messageDialog.id"
                            >
                                <im-card
                                        :model="messageDialog"
                                        :index="index"
                                        :selectedChatId="selectedChatId"
                                        @editModel="editEvent(index)"
                                        @removeModel="removeEvent"
                                        @loadMessagesChat="loadSelectedMessagesChat"
                                ></im-card><!--                                        @loadMessagesChat="loadMessagesChat(value)"-->
                            </v-card-text>
                        </div>
                    </div>
                </v-card>
            </v-col>
          <v-col cols="12" sm="6" md="4" lg="6" class="pa-1 ma-0">
                <v-card class="blue-grey lighten-5">
                    <v-card-title class="ml-2 pa-1">
                        <v-list-item-title class="bold subtitle-1">
                            Чат
                        </v-list-item-title>
                    </v-card-title>
                    <div v-bind:style="[{height: (windowHeight - 160) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                        <div class="content" :ref="'chat_block'">
                            <v-card-text class="pa-0 ma-0"
                                         v-for="(messageDialog, index) in messagesDialogChat"
                                         :key="messageDialog.id"
                            >
                                <im-message

                                        :model="messageDialog"
                                        :user="user"
                                        :index="index"
                                        @editModel="editEvent(index)"
                                        @removeModel="removeEvent"
                                ></im-message><!--                                        @loadMessagesChat="loadMessagesChat(value)"-->
                            </v-card-text>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ImCard from '../../components/bot/im/ImCard'
import ImMessage from '../../components/bot/im/ImMessage'
import { mapGetters } from 'vuex'

export default {
    name: 'Index',
    components: {
        ImCard,
        ImMessage
    },
    data() {
        return {
            dialog: false,
            indexEdit: null,
            windowHeight: 0,
            indexChat: 0,
            selectedChatId: null,
            user: null
        }
    },
    computed: {
        ...mapGetters({
            events: 'events/events',
            messagesDialog: 'messagesDialog/getMessagesDialog',
            messagesDialogChat: 'messagesDialog/getMessagesDialogChat'
        })
    },
    methods: {
        editEvent(index) {
            this.indexEdit = index
            this.dialog = true
        },
        addEvent(data) {
            this.events.push(data)
        },
        removeEvent(index) {
            // this.events.splice(index, 1)
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        },
        loadMessages() {
            this.$store.dispatch('messagesDialog/lastDialogs', this.$route.params['pathMatch'])
        },
        loadSelectedMessagesChat(client) {
            this.selectedChatId = client.id
            this.user = client
            this.loadMessagesChat()
        },
        loadMessagesChat() {
            this.$store.dispatch('messagesDialog/loadMessagesChat', {
                bot_id: this.$route.params['pathMatch'],
                chat_id: this.selectedChatId,
                offset: 0 }).then(response => {
                let slide = this.$refs[`chat_block`]
                slide.scrollTop = slide.scrollHeight
            })
        }
    },
    created() {
        this.loadMessages()
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
